import React, { useEffect, useState } from "react";
import "../styles/Navbar.css";
import {
  FaBars,
  FaTimes,
  FaPhoneAlt,
} from "react-icons/fa";

const Navbar = () => {

  const [sticky,setSticky]=useState(false);
  const [menu,setMenu]=useState(false);

  useEffect(()=>{

      const handleScroll=()=>{

          setSticky(window.scrollY>40);

      }

      window.addEventListener("scroll",handleScroll);

      return ()=>window.removeEventListener("scroll",handleScroll);

  },[])

  return(

<>
<nav className={sticky?"navbar active":"navbar"}>

<div className="nav-logo">

<div className="logo-icon">
IT
</div>

<div>

<h2>ITWORLD</h2>

<p>Fuel Station Technology</p>

</div>

</div>

<ul className={menu?"nav-menu open":"nav-menu"}>

<li><a href="#home">Home</a></li>

<li><a href="#services">Solutions</a></li>

<li><a href="#products">Products</a></li>

<li><a href="#about">About</a></li>

<li><a href="#contact">Contact</a></li>

</ul>

<div className="nav-right">

<div className="call-box">

<FaPhoneAlt/>

<span>0303-9692162</span>

</div>

<button>

Request Demo

</button>

<div
className="mobile-menu"
onClick={()=>setMenu(!menu)}
>

{
menu?<FaTimes/>:<FaBars/>
}

</div>

</div>

</nav>

</>

  )

}

export default Navbar;